import { ArticlesProvider } from "../GetData/Context/ArticlesContext ";
import { PaymentProvider } from "../GetData/Context/PaymentContext";

export default function ({ children }) {
    return (
        <PaymentProvider>
            <ArticlesProvider>
                {children}
            </ArticlesProvider>
        </PaymentProvider>
    )
}